import { animate, motion, useMotionValue } from "framer-motion";
import { useEffect } from "react";
import useMeasure from "react-use-measure";

const MediaPartners: React.FC = () => {
  const mediaPartners = [
    "/images/partners/Infomedpart.png",
    "/images/partners/IkutEvent.jpg",
    "/images/partners/AcaraKampusIndonesia.png",
    "/images/partners/EventMahasiswa.png",
    "/images/partners/BengkelTI.png",
    "/images/partners/lombaitii.png",
    "/images/partners/GandengFoundation.png",
    "/images/partners/OrangSiber.png",
    "/images/partners/CSRelatedCompetitions.png",
  ];

  const [ref, { width }] = useMeasure();
  const xTranslation = useMotionValue(0);

  useEffect(() => {
    const finalPosition = -width / 2 - 8;
    const controls = animate(xTranslation, [0, finalPosition], {
      ease: "linear",
      duration: 25,
      repeat: Infinity,
      repeatType: "loop",
      repeatDelay: 0,
    });
    return controls.stop;
  }, [xTranslation, width]);

  return (
    <section id="media-partner-marquee" className="w-full h-32 overflow-hidden relative">
      <motion.div
        className="absolute left-0 flex gap-4"
        ref={ref}
        style={{ x: xTranslation }}
      >
        {[
          ...mediaPartners,
          ...mediaPartners,
          ...mediaPartners,
          ...mediaPartners,
        ].map((partner, index) => (
          <div
            className="w-72 h-32 rounded-md border border-darkBlue overflow-hidden p-5 backdrop-blur-sm"
            key={index}
          >
            <img
              className="w-full h-full object-contain"
              alt={`media-partner-${index}`}
              src={partner}
            />
          </div>
        ))}
      </motion.div>
    </section>
  );
};

export default MediaPartners;
